import { gsap, ScrollToPlugin } from './cco-gsap-core';

const handlePageLoadWithAnchor = () => {
  // Check if there's a hash in the URL
  if (window.location.hash) {
    const targetId = window.location.hash.substring(1) // Remove the '#' character
    const targetElement = document.getElementById(targetId)

    if (targetElement) {
      const offset = (window.innerWidth < 992) ? 102 : 112;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset - offset + 15

      // Temporarily disable CSS smooth scrolling to prevent conflicts
      const htmlElement = document.documentElement
      const bodyElement = document.body
      const originalHtmlScrollBehavior = htmlElement.style.scrollBehavior
      const originalBodyScrollBehavior = bodyElement.style.scrollBehavior

      htmlElement.style.scrollBehavior = 'auto'
      bodyElement.style.scrollBehavior = 'auto'

      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: targetPosition,
          autoKill: false
        },
        ease: "power2.out",
        overwrite: true,
        onComplete: () => {
          // Restore original scroll behavior
          htmlElement.style.scrollBehavior = originalHtmlScrollBehavior
          bodyElement.style.scrollBehavior = originalBodyScrollBehavior
        }
      })
    }
  }
}

const handlePageLoadWithHighlight = () => {
  // If page has url parameter "highlight", wrap all instances of the value in a "mark" element
  const urlParams = new URLSearchParams(window.location.search)
  const highlightValue = urlParams.get('highlight')

  if (highlightValue) {
    // Check if highlighting has already been applied
    if (document.body.dataset.highlightApplied) return;
    document.body.dataset.highlightApplied = 'true';

    const elementsToHighlight = document.querySelectorAll('div, p, h1, h2, h3, h4, h5, h6, li')

    elementsToHighlight.forEach(element => {
      // Function to highlight text nodes only, avoiding attributes
      const highlightTextNodes = (node) => {
        if (node.nodeType === Node.TEXT_NODE) {
          const regex = new RegExp(`(${highlightValue})`, 'gi')
          if (regex.test(node.textContent)) {
            const highlightedHTML = node.textContent.replace(regex, '<mark>$1</mark>')
            const wrapper = document.createElement('div')
            wrapper.innerHTML = highlightedHTML
            
            // Replace the text node with the highlighted content
            while (wrapper.firstChild) {
              node.parentNode.insertBefore(wrapper.firstChild, node)
            }
            node.parentNode.removeChild(node)
          }
        } else if (node.nodeType === Node.ELEMENT_NODE) {
          // Skip script, style, and existing mark elements
          if (node.tagName !== 'SCRIPT' && node.tagName !== 'STYLE' && node.tagName !== 'MARK') {
            Array.from(node.childNodes).forEach(highlightTextNodes)
          }
        }
      }

      highlightTextNodes(element)
    })

    // Scroll to first instance of "mark" element
    if (window.location.hash) return;
    
    const firstMarkElement = document.querySelector('mark')

    if (firstMarkElement) {
      const offset = (window.innerWidth < 992) ? 102 : 112;
      const targetPosition = firstMarkElement.getBoundingClientRect().top + window.pageYOffset - offset - 60

      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: targetPosition,
          autoKill: false
        },
        ease: "power2.out",
        overwrite: true
      })
    }
  }
}

export const initializeCommonPageScripts = () => {
  handlePageLoadWithAnchor()
  handlePageLoadWithHighlight()
}